import { Component, OnInit } from '@angular/core';

import { LegalNoticeService } from '../../services/legal-notice.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'legal-notice-buttons',
  templateUrl: './legal-notice-buttons.component.html',
})
export class LegalNoticeButtonsComponent implements OnInit {

  public legalNoticeObservable: Observable<{ available: boolean, disclaimer?: string, privacy_policy?: string }>;

  /**
   * Constructor
   *
   * @param {LegalNoticeService} legalNoticeService
   */
  public constructor(private legalNoticeService: LegalNoticeService) {
    this.legalNoticeObservable = this.legalNoticeService.getAvailable();
  }

  /**
   * Initialize the Component
   *
   * @return void
   */
  public ngOnInit(): void {

    // this.legalNoticeService.getAvailable().subscribe((items: {  disclaimer: string, privacy_policy: string }) => {

    // if (items.disclaimer) {
    //   this.disclaimer = items.disclaimer;
    // }
    //
    // if (items.privacy_policy) {
    //   this.privacyPolicy = items.privacy_policy;
    // }
    //
    // // as we need to wait for the styling, having a timeout of 0.5 sec
    // setTimeout(() => {
    //   this.ready = true;
    // }, 500);

    // });
  }

}
